export const PERMISSIONS = {
  STAD_DISPATCH: 'stad_dispatch',
  STAD_ADMIN: 'stad_admin',
  SCHOOL_NET_ADMIN: 'school_net_admin',
  SCHOOL_NET_BEGELEIDER: 'school_net_begeleider',
  SCHOOL_ADMIN: 'school_admin',
  SCHOOL_MEDEWERKER: 'school_medewerker',
  PARTNER_ADMIN: 'partner_admin',
  PARTNER_MEDEWERKER: 'partner_medewerker',
  PARTNER_NIET_FREQUENT: 'partner_niet_frequent'
};

export const PERMISSION_TO_TEXT = {
  [PERMISSIONS.STAD_DISPATCH]: 'Stad Dispatch',
  [PERMISSIONS.STAD_ADMIN]: 'Stad Admin',
  [PERMISSIONS.SCHOOL_NET_ADMIN]: 'School Net Admin',
  [PERMISSIONS.SCHOOL_NET_BEGELEIDER]: 'School Net Begeleider',
  [PERMISSIONS.SCHOOL_MEDEWERKER]: 'School Medewerker',
  [PERMISSIONS.SCHOOL_ADMIN]: 'School Admin',
  [PERMISSIONS.PARTNER_ADMIN]: 'Partner Admin',
  [PERMISSIONS.PARTNER_MEDEWERKER]: 'Partner Medewerker',
  [PERMISSIONS.PARTNER_NIET_FREQUENT]: 'Partner Niet Frequent'
};

export const TEXT_TO_PERMISSION = {
  'Stad Dispatch': PERMISSIONS.STAD_DISPATCH,
  'Stad Admin': PERMISSIONS.STAD_ADMIN,
  'School Net Admin': PERMISSIONS.SCHOOL_NET_ADMIN,
  'School Net Begeleider': PERMISSIONS.SCHOOL_NET_BEGELEIDER,
  'School Medewerker': PERMISSIONS.SCHOOL_MEDEWERKER,
  'School Admin': PERMISSIONS.SCHOOL_ADMIN,
  'Partner Admin': PERMISSIONS.PARTNER_ADMIN,
  'Partner Medewerker': PERMISSIONS.PARTNER_MEDEWERKER,
  'Partner Niet Frequent': PERMISSIONS.PARTNER_NIET_FREQUENT
};
